export default function CapitalizeText(text) {
  if (text) {
    const lowerCasedText = text.toLowerCase();
    const formattedText = lowerCasedText.split("_").join(" ");
    return formattedText.charAt(0).toUpperCase() + formattedText.slice(1);
  } else return "";
}
